<template>
  <div class="container">

    <div class="search">
      <p>这里是您之前删除的内容，再次删除后将无法再找回。</p>
      <div>
        
        <template v-if="!batchingObj.isOn">
          <l-button
            :shape="2"
            value="批量处理"
            color="#3170FF"
            class="bt1"
            @click.native="batchingStart()"
          ></l-button>
        </template>

        <template v-if="batchingObj.isOn">
          <l-button
            :shape="2"
            value="批量删除"
            color="#3170FF"
            class="bt1"
            @click.native="batchingDelete()"
          ></l-button>
          <l-button
            :shape="2"
            value="结束操作"
            color="#159BE0"
            class="bt1"
            @click.native="batchingEnd()"
          ></l-button>
        </template>

        <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchContent">
          <template slot="append">
            <span @click="getRenderInfo({page: 1})">搜索</span>
          </template>
        </el-input>
      </div>
    </div>

    <div class="mainConainer"
      v-loading="batchingObj.loading"
      :element-loading-text="batchingObj.loadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="head">
        <div
          :class="currentRecycleBin==index?'recycleBinType active':'recycleBinType'"
          v-for="(item,index) in recycleBinType"
          :key="index"
          @click="switchTag(index)"
        >
          <span v-show="item.total">{{item.total}}</span>
          {{item.name}}
        </div>
      </div>

      <div class="content">
        <template v-if="currentRecycleBin==0">
        <table class="table table1" cellspacing="0">
          <tr>
            <th>
              <div>
                <input
                  type="checkbox"
                  class="checkboxAll"
                  v-model="checkboxAll"
                  @change="selectAll"
                >
                全选
              </div>
              <div @click="pullDown(0)">
                用户姓名
                <i class="el-icon-caret-bottom"></i>
                <eject-select-list class="select" :show.sync="isShowScreen[0]">
                  <p :class="{'on':queryObj.userName == 'asc'}"  @click="getRenderInfo({userName:'asc',time:'',})">按拼音（正序）</p>
                  <p :class="{'on':queryObj.userName == 'desc'}" @click="getRenderInfo({userName:'desc',time:'',})">按拼音（倒序）</p>
                </eject-select-list>
              </div>
            </th>

            <th @click="pullDown(3)">所在部门
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[3]">
                <p :class="{'on':queryObj.class == ''}" @click="getRenderInfo({class:'',page: 1})">全部</p>
                <p
                  v-for="(item,index) in options[3]"
                  :key="index"
                  :class="{'on':queryObj.class == item.deptid}"
                  @click="getRenderInfo({class:item.deptid,page: 1})"
                >{{item.deptname}}</p>
              </eject-select-list>
            </th>

            <th>编号</th>

            <th @click="pullDown(2)">性别
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[2]">
                <p :class="{'on':queryObj.sex == ''}" @click="getRenderInfo({sex:'',page: 1})">全部</p>
                <p :class="{'on':queryObj.sex == '男'}" @click="getRenderInfo({sex:'男',page: 1})">男</p>
                <p :class="{'on':queryObj.sex == '女'}" @click="getRenderInfo({sex:'女',page: 1})">女</p>
              </eject-select-list>
            </th>

            <th>注册账号</th>

            <th @click="pullDown(4)">用户等级
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[4]">
                <p :class="{'on':queryObj.status === ''}" @click="getRenderInfo({status:'',page: 1})">全部</p>
                <p
                  v-for="(item,index) in options[4]"
                  :key="index"
                  :class="{'on':queryObj.status === item.value}"
                  @click="getRenderInfo({status:item.value,page: 1})"
                >{{item.label}}</p>
              </eject-select-list>
            </th>
            <th @click="pullDown(5)">删除日期
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select selectTime" :show.sync="isShowScreen[5]">
                <l-date-picker v-model="queryObj.date" @change="getRenderInfo({page:1})"></l-date-picker>
                <p :class="{'on':queryObj.time == 'asc'}" @click="getRenderInfo({time:'asc',userName:''})">按最远建立排序</p>
                <p :class="{'on':queryObj.time == 'desc'}" @click="getRenderInfo({time:'desc',userName:''})">按最近建立排序</p>
              </eject-select-list>
            </th>
            <th v-if="!batchingObj.isOn">操作</th>
          </tr>

        </table>
        <table v-if="!batchingObj.isOn" class="table table1" cellspacing="0">

          <tr
            v-for="(item,index) in userInfo"
            :key="index"
            @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }"
          >
            <td>
              <input
                type="checkbox"
                v-model="checkbox[index]"
                @change="selectItem"
              >
            
              <div class="avatar">
                <img :src="global.ip + item.avatar">
              </div>
              <div class="userName">
                {{item.nickname}}
              </div>

            </td>
            <td>
              {{item.deptname}}
            </td>
            <td>
              {{item.uid}}
            </td>
            <td>
              {{item.sex}}
            </td>
            <td>
              {{item.username}}
            </td>
            <td>
              {{item.level==0?'普通用戶':item.level==1?'管理员':item.level==2?'超级管理员':item.level==3?'专家':""}}
            </td>
            <td>
              {{item.deleteTime}}
            </td>
            <td>
              <button @click="submitRestore(item)">还原</button>
              <button @click="submitDelete(item)">删除</button>
            </td>

          </tr>

        </table>

          <big-data-roll class="data-table" v-if="batchingObj.isOn" :list="userInfo" :rowHeight="57">
            <template v-slot:default="slotProps">
              <table class="table table1" cellspacing="0">

                <tr
                  v-for="(item,index) in slotProps.list"
                  :key="item.index"
                  @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }"
                >
                  <td>
                    <input
                      type="checkbox"
                      v-model="checkbox[item.index]"
                      @change="selectItem"
                    >
                  
                    <div class="avatar">
                      <img :src="global.ip + item.avatar">
                    </div>
                    <div class="userName">
                      {{item.nickname}}
                    </div>

                  </td>
                  <td>
                    {{item.deptname}}
                  </td>
                  <td>
                    {{item.uid}}
                  </td>
                  <td>
                    {{item.sex}}
                  </td>
                  <td>
                    {{item.username}}
                  </td>
                  <td>
                    {{item.level==0?'普通用戶':item.level==1?'管理员':item.level==2?'超级管理员':item.level==3?'专家':""}}
                  </td>
                  <td>
                    {{item.deleteTime}}
                  </td>

                </tr>

              </table>
            </template>
          </big-data-roll>
        </template>

        <template v-if="currentRecycleBin==1">
        <table class="table table2" cellspacing="0">
          <tr>
            <th>
              <div>
                <input
                  type="checkbox"
                  class="checkboxAll"
                  v-model="checkboxAll"
                  @change="selectAll"
                >
                全选
              </div>
              <div @click="pullDown(0)">
                量表/题库
                <i class="el-icon-caret-bottom"></i>
                <eject-select-list class="select" :show.sync="isShowScreen[0]">
                  <p :class="{'on':queryObj.type == ''}" @click="getRenderInfo({type:'',page: 1})">全部</p>
                  <p
                    v-for="(item,index) in reportType"
                    :key="index"
                    :class="{'on':queryObj.type == item}"
                    @click="getRenderInfo({type:item,page: 1})"
                  >{{item}}</p>
                </eject-select-list>
              </div>
            </th>
            <th @click="pullDown(3)">所属分类
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[3]">
                <p :class="{'on':queryObj.category == ''}" @click="getRenderInfo({category:'',page: 1})">全部</p>
                <p
                  v-for="(item,index) in allCategory"
                  :key="index"
                  :class="{'on':queryObj.category == item}"
                  @click="getRenderInfo({category:item,page: 1})"
                >{{item.name}}</p>
              </eject-select-list>
            </th>

            <th @click="pullDown(1)">包含分卷

            </th>

            <th @click="pullDown(2)">编写人
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[2]">
                <p :class="{'on':queryObj.user == ''}" @click="getRenderInfo({user:'',page: 1})">全部</p>
                <p
                  v-for="(item,index) in allEditor"
                  :key="index"
                  :class="{'on':queryObj.user == item.addUid}"
                  @click="getRenderInfo({user:item.addUid,page: 1})"
                >{{item.nickname}}</p>
              </eject-select-list>
            </th>

            <th @click="pullDown(4)">删除日期
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select selectTime" :show.sync="isShowScreen[4]">
                <l-date-picker v-model="queryObj.date" @change="getRenderInfo({page:1})"></l-date-picker>
                <p :class="{'on':queryObj.time == 'asc'}" @click="getRenderInfo({time:'asc',userName:''})">按最远建立排序</p>
                <p :class="{'on':queryObj.time == 'desc'}" @click="getRenderInfo({time:'desc',userName:''})">按最近建立排序</p>
              </eject-select-list>
            </th>
            <th v-if="!batchingObj.isOn">操作</th>
          </tr>

        </table>
        <table v-if="!batchingObj.isOn" class="table table2" cellspacing="0">

          <tr
            v-for="(item,index) in userInfo"
            :key="index"
            @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }"
          >
            <td>
              <input
                type="checkbox"
                v-model="checkbox[index]"
                @change="selectItem"
              >

              <span class="label" :style="labelStyle[item.catName]">{{item.catName}}</span>
              {{item.name}}
            </td>
            <td>
              {{item.categoryName}}
            </td>
            <td>
              ---
            </td>
            <td>
              {{item.editorName}}
            </td>
            <td>
              {{item.deleteDay}}
            </td>
            <td>
              <button @click="submitRestore(item)">还原</button>
              <button @click="submitDelete(item)">删除</button>
            </td>

          </tr>

        </table>

          <big-data-roll class="data-table" v-if="batchingObj.isOn" :list="userInfo" :rowHeight="57">
            <template v-slot:default="slotProps">

              <table class="table table2" cellspacing="0">

                <tr
                  v-for="(item,index) in slotProps.list"
                  :key="item.index"
                  @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }"
                >
                  <td>
                    <input
                      type="checkbox"
                      v-model="checkbox[item.index]"
                      @change="selectItem"
                    >

                    <span class="label" :style="labelStyle[item.catName]">{{item.catName}}</span>
                    {{item.name}}
                  </td>
                  <td>
                    {{item.categoryName}}
                  </td>
                  <td>
                    ---
                  </td>
                  <td>
                    {{item.editorName}}
                  </td>
                  <td>
                    {{item.deleteDay}}
                  </td>

                </tr>

              </table>

            </template>
          </big-data-roll>

        </template>

        <template v-if="currentRecycleBin==2">
        <table class="table table3" cellspacing="0">
          <tr>
            <th>
              <div>
                <input
                  type="checkbox"
                  class="checkboxAll"
                  v-model="checkboxAll"
                  @change="selectAll"
                >
                全选
              </div>
              <div @click="pullDown(0)">
                测评项目名称
                <i class="el-icon-caret-bottom"></i>
                <eject-select-list class="select" :show.sync="isShowScreen[0]">
                  <p :class="{'on':queryObj.title == 'asc'}"  @click="getRenderInfo({title:'asc',userName:'',time:'',})">按拼音（正序）</p>
                  <p :class="{'on':queryObj.title == 'desc'}" @click="getRenderInfo({title:'desc',userName:'',time:'',})">按拼音（倒序）</p>
                </eject-select-list>
              </div>
            </th>
            <th @click="pullDown(1)">所属分类
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[1]">
                <p :class="{'on':queryObj.category == ''}" @click="getRenderInfo({category:'',page: 1})">全部</p>
                <p
                  v-for="(item,index) in allCategory"
                  :key="index"
                  :class="{'on':queryObj.category == item}"
                  @click="getRenderInfo({category:item,page: 1})"
                >{{item.name}}</p>
              </eject-select-list>
            </th>

            <th @click="pullDown(2)">报告生成日期

            </th>

            <th @click="pullDown(7)">测评用户
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[7]">
                <p :class="{'on':queryObj.userName == 'asc'}"  @click="getRenderInfo({title:'',userName:'asc',time:'',})">按拼音（正序）</p>
                <p :class="{'on':queryObj.userName == 'desc'}" @click="getRenderInfo({title:'',userName:'desc',time:'',})">按拼音（倒序）</p>
              </eject-select-list>
            </th>

            <th @click="pullDown(4)">
              所在部门
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[4]">
                <p :class="{'on':queryObj.class == ''}" @click="getRenderInfo({class:'',page: 1})">全部</p>
                <p
                  v-for="(item,index) in classList"
                  :key="index"
                  :class="{'on':queryObj.class == item.deptid}"
                  @click="getRenderInfo({class:item.deptid,page: 1})"
                >{{item.deptname}}</p>
              </eject-select-list>
            </th>

            <th>编号</th>

            <th @click="pullDown(6)">性别
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select" :show.sync="isShowScreen[6]">
                <p :class="{'on':queryObj.sex == ''}" @click="getRenderInfo({sex:'',page: 1})">全部</p>
                <p :class="{'on':queryObj.sex == '男'}" @click="getRenderInfo({sex:'男',page: 1})">男</p>
                <p :class="{'on':queryObj.sex == '女'}" @click="getRenderInfo({sex:'女',page: 1})">女</p>
              </eject-select-list>
            </th>
            <th @click="pullDown(5)">
              删除日期
              <i class="el-icon-caret-bottom"></i>
              <eject-select-list class="select selectTime" :show.sync="isShowScreen[5]">
                <l-date-picker v-model="queryObj.date" @change="getRenderInfo({page:1})"></l-date-picker>
                <p :class="{'on':queryObj.time == 'asc'}" @click="getRenderInfo({title:'',userName:'',time:'asc'})">按最远建立排序</p>
                <p :class="{'on':queryObj.time == 'desc'}" @click="getRenderInfo({title:'',userName:'',time:'desc'})">按最近建立排序</p>
              </eject-select-list>
            </th>
            <th v-if="!batchingObj.isOn">操作</th>
          </tr>

          </table>
          <table v-if="!batchingObj.isOn" class="table table3" cellspacing="0">

          <tr
            v-for="(item,index) in userInfo"
            :key="index"
            @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }"
          >
            <td>
              <input
                type="checkbox"
                v-model="checkbox[index]"
                @change="selectItem"
              >

              <span class="label" :style="labelStyle[item.catName]">{{item.catName}}</span>
              <div class="userName">
                {{item.title}}
              </div>

            </td>
            <td>
              {{item.categoryName}}
            </td>
            <td>
              {{item.addDay}}
            </td>
            <td style="text-align: left;">
              <div>
                <div class="avatar">
                  <img :src="global.ip+item.avatar">
                </div>
                <div class="nickName">{{item.nickname}}</div>
              </div>
            </td>
            <td>
              {{item.deptname}}
            </td>
            <td>
              {{item.id}}
            </td>
            <td>{{item.sex}}</td>
            <td>{{item.deleteDay}}</td>
            <td>
              <button @click="submitRestore(item)">还原</button>
              <button @click="submitDelete(item)">删除</button>
            </td>

          </tr>

        </table>

          <big-data-roll class="data-table" v-if="batchingObj.isOn" :list="userInfo" :rowHeight="57">
            <template v-slot:default="slotProps">

              <table class="table table3" cellspacing="0">
                <tr
                  v-for="(item,index) in slotProps.list"
                  :key="item.index"
                  @click="nowClickRow = item" :style="{ 'background': nowClickRow == item ? '#e0f0ff' : '' }"
                >
                  <td>
                    <input
                      type="checkbox"
                      v-model="checkbox[item.index]"
                      @change="selectItem"
                    >

                    <span class="label" :style="labelStyle[item.catName]">{{item.catName}}</span>
                    <div class="userName">
                      {{item.title}}
                    </div>

                  </td>
                  <td>
                    {{item.categoryName}}
                  </td>
                  <td>
                    {{item.addDay}}
                  </td>
                  <td style="text-align: left;">
                    <div>
                      <div class="avatar">
                        <img :src="global.ip+item.avatar">
                      </div>
                      <div class="nickName">{{item.nickname}}</div>
                    </div>
                  </td>
                  <td>
                    {{item.deptname}}
                  </td>
                  <td>
                    {{item.id}}
                  </td>
                  <td>{{item.sex}}</td>
                  <td>{{item.deleteDay}}</td>

                </tr>

              </table>

            </template>
          </big-data-roll>

        </template>

        <el-pagination
          v-if="!batchingObj.isOn"
          class="page"
          background
          layout="prev, pager, next"
          :total="queryObj.total"
          :page-size="queryObj.pageSize"
          :current-page="queryObj.page"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>
    <l-dialog
      :show="showHiddenWindow"
      @cancel="hiddenWindow"
      @save="submit"
      title="新增/编辑用户"
      class="addWidnow"
    >
      <div class="wrap">
        <div class="register">
          <div class="explain">注册账号:</div>
          <input
            type="text"
            class="user"
            v-model="user"
            :disabled="isEdit"
          >
        </div>

        <div class="setPWD">
          <div class="explain">设置密码:</div>
          <input
            type="password"
            class="PWD"
            v-model="password"
          >

          <button class="speedinessSet">快速设置</button>
        </div>

        <div class="explain">正在申请找回密码，申请理由：密码不记得了。</div>

        <div class="userNameAndSex">
          <div class="explain">用户姓名:</div>
          <input
            type="text"
            class="userName"
            v-model="userName"
          >
          <div class="explainSex">性别:</div>

          <el-select
            v-model="sexValue"
            placeholder="请选择"
            class="sexArr"
          >
            <el-option
              v-for="(item,index) in sex"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>

        <div class="classAndSerialNumber">
          <div class="explain">部门</div>
          <el-select
            v-model="classValue"
            placeholder="请选择"
            class="classList"
            @change="selectClass"
          >
            <el-option
              v-for="(item,index) in classList"
              :key="index"
              :label="item.deptname"
              :value="item.deptid"
            >
            </el-option>
          </el-select>

          <div class="explainSerialNumber">序号:</div>
          <input
            type="text"
            class="serialNumber"
            v-model="classSerialNumber"
            disabled
          >
        </div>
      </div>

    </l-dialog>
  </div>
</template>

<script>
import { formatDate2 } from "@/utils/common/formatDate.js";
export default {
  data() {
    return {
      nowClickRow: null,
      //题库回收站时间
      selectDateTwo: "",
      // 回收站类型
      recycleBinType: [
        { name: "用户账号回收站", total: 0, },
        { name: "题库回收站", total: 0, },
        { name: "测评结果回收站", total: 0, },
      ],
      // 当前回收站
      currentRecycleBin: 0,
      //用户姓名筛选
      userNameOptionValue: "",
      // 测评用户名
      userNameAppraisalOptionValue: "",
      // 序号筛选
      serialNumberOptionValue: "",
      // 性别筛选
      sexOptionValue: "",
      // 所在部门筛选
      classOptionValue: "",
      // 账号状态筛选
      userStatusOptionValue: "",
      //用户账号
      user: "",
      // 密码
      password: "",
      // 用户姓
      userName: "",
      // 性别
      sexValue: "",
      sex: ["男", "女"],
      // 用户信息
      userInfo: [],
      // 是否全选
      checkboxAll: false,
      checkbox: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      // 弹窗显示和隐藏
      showHiddenWindow: false,
      // 部门列表
      classList: [],
      classValue: "",
      classSerialNumber: "",
      // 当前页
      page: 1,
      // 总数
      total: 0,
      pageSize: 9,
      // 是否是编辑
      isEdit: false,
      // 编辑的id
      editId: "",
      // 显示和隐藏表格标题的筛选选项
      isShowScreen: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      // option中的所有选项
      options: [
        ["按拼音（正序）", "按拼音（倒序）"],
        ["正序", "倒序"],
        ["全部", "男", "女"],
        ["按拼音（正序）", "按拼音（倒序）"],
        [
          { label: "普通用户", value: 0 },
          { label: "管理员", value: 1 },
          { label: "超级管理员", value: 2 },
          { label: "专家", value: 3 },
        ],
        [],
        ["全部", "男", "女"],
        ["按拼音（正序）", "按拼音（倒序）"],
      ],
      // 修改的编号
      studentId: "",
      // 还原的id
      restoreUid: "",
      // 筛选的时间
      selectDate: [],
      // 测评结果分类
      reportType: [],
      reportTypeValue: "",
      // 所属分类
      allCategory: [],
      allCategoryValue: "",
      // 所有编写人
      allEditor: [],
      allEditorValue: "",
      //搜索的内容
      searchContent: "",
      //  测评结果回收站时间
      selectDateThreen: "",

      queryObj: {
        sex: '',
        class: '',
        userName: '',
        date: [],
        time: '',
        status: '',
        type: '',
        category: '',
        title: '',
        page: 1,
        pageSize: 10,
        total: 0,
      },
      labelStyle: {
        '量表': { 'background-color': '#ffede6', 'border-color': '#ffa785', 'color': '#ff500c' },
        '普查': { 'background-color': '#FDF8E5', 'border-color': '#F7DD7F', 'color': '#EFBC00' },
        '问卷': { 'background-color': '#E7F5FC', 'border-color': '#8ACDEF', 'color': '#159BE0' },
        '团体': { 'background-color': '#E5EDFF', 'border-color': '#7FA6FF', 'color': '#004EFF' },
        // '预警': { 'background-color': '#ffede6', 'border-color': '#ffa785', 'color': '#ff500c' },
      },

      batchingObj: {
        isOn: false,
        loading: false,
        loadingText: '',
        dataNum: 0,
      },
    };
  },
  watch: {
  },
  methods: {
    // 获取测评结果分类
    async getReportType() {
      const { data } = await this.$post("api/system/recycle/getReportType");
      this.reportType = data.data.list;
    },
    switchTag(index) {
      this.batchingObj.isOn = false
      this.batchingObj.loading = false

      this.currentRecycleBin = index;
      this.queryObj.sex = ''
      this.queryObj.class = ''
      this.queryObj.userName = ''
      this.queryObj.date = []
      this.queryObj.time = ''
      this.queryObj.status = ''
      this.queryObj.type = ''
      this.queryObj.category = ''
      this.queryObj.title = ''
      this.getRenderInfo({page: 1})
    },
    //確認還原
    submitRestore(itemObj) {
      if (this.currentRecycleBin === 0) {
        let indexArr = this.checkbox.map((item, index) => {
          if (item == true) {
            return index;
          }
        });
        const indexArrSuccess = indexArr.filter((item) => {
          return item !== undefined;
        });
        let uids = [];
        indexArrSuccess.forEach((item) => {
          uids.push(this.userInfo[item].uid);
        })
        if (uids.length <= 0) {
          uids.push(itemObj.uid)
        }
        this.$popup({
          title: '提示',
          content: '确定要还原此内容吗？',
          saveFoo: () => {
            this.$post("api/system/recycle/delUserOperate", {
              type: 2,
              operateUids: uids.toString(),
            }).then(({ data })=>{
              if (data.code == "0") {
                this.getRenderInfo();
              }
            })
          },
        })
      } else if (this.currentRecycleBin === 1) {
        let indexArr = this.checkbox.map((item, index) => {
          if (item == true) {
            return index;
          }
        });
        const indexArrSuccess = indexArr.filter((item) => {
          return item !== undefined;
        });
        let operateArr = [];
        indexArrSuccess.forEach((item) => {
          operateArr.push({
            id: this.userInfo[item].id,
            catName: this.userInfo[item].catName,
          });
        });
        if (operateArr.length <= 0) {
          operateArr.push({
            id: itemObj.id,
            catName: itemObj.catName,
          })
        }
        this.$popup({
          title: '提示',
          content: '确定要还原此内容吗？',
          saveFoo: () => {
            this.$post("api/system/recycle/delQBOperate", {
              type: 2,
              operateArr: operateArr,
            }).then(({ data })=>{
              if (data.code == "0") {
                this.getRenderInfo();
              }
            })
          },
        })
      } else {
        let indexArr = this.checkbox.map((item, index) => {
          if (item == true) {
            return index;
          }
        });
        const indexArrSuccess = indexArr.filter((item) => {
          return item !== undefined;
        });
        let operateArr = [];
        indexArrSuccess.forEach((item) => {
          operateArr.push({
            id: this.userInfo[item].id,
            catName: this.userInfo[item].catName,
          });
        });
        if (operateArr.length <= 0) {
          operateArr.push({
            id: itemObj.id,
            catName: itemObj.catName,
          })
        }
        this.$popup({
          title: '提示',
          content: '确定要还原此内容吗？',
          saveFoo: () => {
            this.$post(
              "api/system/recycle/delReportOperate",
              {
                type: 2,
                operateArr: operateArr,
              }
            ).then(({ data })=>{
              if (data.code == "0") {
                this.getRenderInfo();
              }
            })
          },
        })
      }
    },
    // 日期格式化
    formatDate(date) {
      const startYear = date[0].getFullYear();
      const startMonth =
        date[0].getMonth() + 1 < 10
          ? "0" + (date[0].getMonth() + 1)
          : date[0].getMonth() + 1;
      const startDay =
        date[0].getDate() < 10 ? "0" + date[0].getDate() : date[0].getDate();
      const dateOne = startYear + "-" + startMonth + "-" + startDay;
      const endYear = date[1].getFullYear();
      const endMonth =
        date[1].getMonth() + 1 < 10
          ? "0" + (date[1].getMonth() + 1)
          : date[1].getMonth() + 1;
      const endDay =
        date[1].getDate() < 10 ? "0" + date[1].getDate() : date[1].getDate();
      const dateTwo = endYear + "-" + endMonth + "-" + endDay;
      return [dateOne, dateTwo];
    },
    // 表格筛选
    pullDown(index, e) {
      // console.log(e);
      this.$set(this.isShowScreen, index, !this.isShowScreen[index]);
    },
    // 确认删除
    submitDelete(itemObj) {
      if (this.currentRecycleBin === 0) {
        let index = this.checkbox.map((item, index) => {
          if (item) {
            return index;
          }
        });

        index = index.filter((item) => {
          return item !== undefined;
        });

        let deleteId = [],
            content = '从回收站内删除后，将无法找回，确认删除吗？'
        if (index.length) {
          index.forEach((item) => {
            deleteId.push(this.userInfo[item].uid);
          });
        } else {
          deleteId.push(itemObj.uid)
        }
        this.$popup({
          title: '提示',
          content: content,
          saveFoo: () => {
            this.$post("api/system/recycle/delUserOperate", {
              operateUids: deleteId.toString(),
              type: 1,
            }).then(({ data })=>{
              if (data.code == "0") {
                // 处理删除整页的情况，当不是最后一页时，当前页数减一
                if (deleteId.length == this.userInfo.length) {
                  // 判断是否为最后一页
                  if (this.queryObj.page == Math.ceil(this.queryObj.total / this.queryObj.pageSize)) {
                    this.queryObj.page = this.queryObj.page > 1 ? this.queryObj.page - 1 : 1;
                  }
                }
                this.getRenderInfo();
              }
            })
          },
        })
      } else if (this.currentRecycleBin === 1) {
        let indexArr = this.checkbox.map((item, index) => {
          if (item == true) {
            return index;
          }
        });
        const indexArrSuccess = indexArr.filter((item) => {
          return item !== undefined;
        });
        let operateArr = [],
            content = '从回收站内删除后，将无法找回，确认删除吗？'
        indexArrSuccess.forEach((item) => {
          operateArr.push({
            id: this.userInfo[item].id,
            catName: this.userInfo[item].catName,
          });
        });
        if (operateArr.length <= 0) {
          operateArr.push({
            id: itemObj.id,
            catName: itemObj.catName,
          })
        }
        this.$popup({
          title: '提示',
          content: content,
          saveFoo: () => {
            this.$post("api/system/recycle/delQBOperate", {
              type: 1,
              operateArr: operateArr,
            }).then(({ data })=>{
              if (data.code == "0") {
                // 处理删除整页的情况，当不是最后一页时，当前页数减一
                if (operateArr.length == this.userInfo.length) {
                  // 判断是否为最后一页
                  if (this.queryObj.page == Math.ceil(this.queryObj.total / this.queryObj.pageSize)) {
                    this.queryObj.page = this.queryObj.page > 1 ? this.queryObj.page - 1 : 1;
                  }
                }
                this.getRenderInfo();
              }
            })
          },
        })
      } else if (this.currentRecycleBin === 2) {
        let indexArr = this.checkbox.map((item, index) => {
          if (item == true) {
            return index;
          }
        });
        const indexArrSuccess = indexArr.filter((item) => {
          return item !== undefined;
        });
        let operateArr = [],
            content = '从回收站内删除后，将无法找回，确认删除吗？'
        indexArrSuccess.forEach((item) => {
          operateArr.push({
            id: this.userInfo[item].id,
            catName: this.userInfo[item].catName,
          });
        });
        if (operateArr.length <= 0) {
          operateArr.push({
            id: itemObj.id,
            catName: itemObj.catName,
          })
        }
        this.$popup({
          title: '提示',
          content: content,
          saveFoo: () => {
            this.$post(
              "api/system/recycle/delReportOperate",
              {
                type: 1,
                operateArr: operateArr,
              }
            ).then(({ data })=>{
              if (data.code == "0") {
                // 处理删除整页的情况，当不是最后一页时，当前页数减一
                if (operateArr.length == this.userInfo.length) {
                  // 判断是否为最后一页
                  if (this.queryObj.page == Math.ceil(this.queryObj.total / this.queryObj.pageSize)) {
                    this.queryObj.page = this.queryObj.page > 1 ? this.queryObj.page - 1 : 1;
                  }
                }
                this.getRenderInfo();
              }
            })
          },
        })
      }
    },

    // 切换分页
    changePage(page) {
      this.queryObj.page = page;
      this.getRenderInfo();
    },
    //编辑用户资料
    edit(item) {
      this.user = item.username;
      this.password = item.password;
      this.userName = item.nickname;
      this.sexValue = item.sex;
      this.classValue = item.deptname;
      this.classSerialNumber = item.deptid;
      this.showHiddenWindow = true;
      this.isEdit = true;
      this.editId = item.uid;
      this.studentId = item.studentId;
      this.$forceUpdate();
    },
    //新增用户
    async submit() {
      if (this.isEdit) {
        const { data } = await this.$post("api/index/reset", {
          id: this.editId,
          pwd: this.password,
          nickname: this.userName,
          dept: this.classSerialNumber,
          sex: this.sexValue,
          studentId: this.studentId,
        });
        if (data.code === "0") {
          this.user = "";
          this.password = "";
          this.userName = "";
          this.classSerialNumber = "";
          this.classValue = "";
          this.sexValue = "";
          this.isEdit = false;
          this.showHiddenWindow = false;
          this.getRenderInfo();
        }
      } else {
        const { data } = await this.$post("api/index/register", {
          username: this.user,
          pwd: this.password,
          nickname: this.userName,
          deptid: this.classSerialNumber,
          sex: this.sexValue,
          status: 2,
        });
        if (data.code === "0") {
          this.user = "";
          this.password = "";
          this.userName = "";
          this.classSerialNumber = "";
          this.classValue = "";
          this.sexValue = "";
          this.showHiddenWindow = false;
          this.getRenderInfo();
        }
      }
    },
    //选择部门
    selectClass(value) {
      this.classSerialNumber = value;
    },
    // 获取部门列表
    async getClassList() {
      const { data } = await this.$post("api/msg/someDept");
      this.classList = data.data.list;
      this.$set(this.options, 3, data.data.list);
    },
    //隐藏新增用户弹窗
    hiddenWindow() {
      this.showHiddenWindow = false;
    },
    //显示新增用户弹窗
    showAddWidnow() {
      this.user = "";
      this.password = "";
      this.userName = "";
      this.classSerialNumber = "";
      this.classValue = "";
      this.sexValue = "";
      this.isEdit = false;
      this.showHiddenWindow = true;
    },
    // 单选
    selectItem() {
      this.checkboxAll = this.checkbox.every((item) => {
        return item;
      });
    },
    // 全选
    selectAll() {
      this.checkbox = this.checkbox.map((item) => {
        item = this.checkboxAll;
        return item;
      });
    },
    getTypeNum () {
      this.$post("api/system/recycle/delUserList", {
        curPage: 1,
        pageSize: 1,
      }).then(({data}) => {
        // console.log(data.data)
        this.recycleBinType[0].total = data.data.total;
        this.$forceUpdate()
      })
      this.$post("api/system/recycle/delQBList", {
        curPage: 1,
        pageSize: 1,
      }).then(({data}) => {
        // console.log(data.data)
        this.recycleBinType[1].total = data.data.total;
        this.$forceUpdate()
      })
      this.$post("api/system/recycle/delReportList", {
        curPage: 1,
        pageSize: 1,
      }).then(({data}) => {
        // console.log(data.data)
        this.recycleBinType[2].total = data.data.total;
        this.$forceUpdate()
      })
    },
    // 获取表格信息
    async getRenderInfo(qObj = this.queryObj) {
      qObj = Object.assign(this.queryObj, qObj)

      // 批量处理数据
      if (this.batchingObj.isOn) {
        this.batchingGetTableData(qObj)
        return
      }

      this.userInfo = [];
      this.checkbox.length = 0;
      this.queryObj.total = 0;
      let nowIndex = this.currentRecycleBin
      if (nowIndex == 0) {
        const { data } = await this.$post("api/system/recycle/delUserList", {
          curPage: qObj.page,
          pageSize: qObj.pageSize,
          name: this.searchContent,
          sex: qObj.sex,
          deptid: qObj.class,
          delStartdate: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
          delEnddate: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
          title_desc: qObj.userName,
          time_desc: qObj.time,
          level: qObj.status,
        });
        this.userInfo = data.data.list;
        this.checkbox.length = this.userInfo.length;
        for (let i = 0; i < this.checkbox.length; i++) {
          this.checkbox[i] = false;
        }

        this.queryObj.total = data.data.total;
        this.recycleBinType[nowIndex].total = data.data.total;
      } else if (nowIndex == 1) {
        const { data } = await this.$post("api/system/recycle/delQBList", {
          curPage: qObj.page,
          pageSize: qObj.pageSize,
          catName: qObj.type,
          name: this.searchContent,
          categoryName: qObj.category,
          addUid: qObj.user,
          delStartdate: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
          delEnddate: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
          deltime_desc: qObj.time,
        });
        this.userInfo = data.data.list;
        this.checkbox.length = this.userInfo.length;
        for (let i = 0; i < this.checkbox.length; i++) {
          this.checkbox[i] = false;
        }

        this.queryObj.total = data.data.total;
        this.recycleBinType[nowIndex].total = data.data.total;
      } else if (nowIndex === 2) {
        const { data } = await this.$post("api/system/recycle/delReportList", {
          curPage: qObj.page,
          pageSize: qObj.pageSize,
          sex: qObj.sex,
          name: this.searchContent,
          name_desc: qObj.title,
          categoryName: qObj.category,
          nickname_desc: qObj.userName,
          delStartdate: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
          delEnddate: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
          deltime_desc: qObj.time,
          deptid: qObj.class,
        });
        this.userInfo = data.data.list;
        this.checkbox.length = this.userInfo.length;
        for (let i = 0; i < this.checkbox.length; i++) {
          this.checkbox[i] = false;
        }

        this.queryObj.total = data.data.total;
        this.recycleBinType[nowIndex].total = data.data.total;
      }
    },
    // 获取所属分类
    async getAllCategory() {
      const { data } = await this.$post("api/system/recycle/getAllCategory");
      this.allCategory = data.data.list;
    },
    // 获取编写人
    async getAllEditor() {
      const { data } = await this.$post("api/system/recycle/getAllEditor");
      this.allEditor = data.data.list;
    },


    

    //============================
    // 数据批量操作

    batchingStart () {
      this.batchingObj.isOn = true
      this.batchingObj.loading = true
      this.getRenderInfo()
    },

    batchingEnd () {
      this.batchingObj.isOn = false
      this.batchingObj.loading = false
      this.getRenderInfo({page: 1})
    },


    batchingDelete () {
      let index = this.checkbox.map((item, index) => {
        if (item) {
          return index;
        }
      });
      index = index.filter((item) => {
        return item !== undefined;
      });

      if (index.length == 0) {
        this.$myMessage('请勾选需要操作的数据')
        return
      }

      let deleteId = '',
          content = '是否要删除勾选的' + index.length + '条数据？'
      index.forEach((item) => {
        deleteId += this.userInfo[item].uid + ",";
      });

      this.$popup({
        title: '提示',
        content: content,
        saveFoo: () => {
          const loading = this.$loading({
            lock: true,
            text: '处理中，请稍等',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          if (this.currentRecycleBin === 0) {
            this.$post("api/system/recycle/delUserOperate", {
              operateUids: deleteId.toString(),
              type: 1,
            }).then(({ data })=>{
              if (data.code == "0") {
                this.getRenderInfo();
              }
              loading.close();
            }).catch((err) => {
              loading.close();
            });
          } else if (this.currentRecycleBin === 1) {
            let operateArr = index.map((item)=>{
              return {
                id: this.userInfo[item].id,
                catName: this.userInfo[item].catName,
              }
            })
            this.$post("api/system/recycle/delQBOperate", {
              type: 1,
              operateArr: operateArr,
            }).then(({ data })=>{
              if (data.code == "0") {
                this.getRenderInfo();
              }
              loading.close();
            }).catch((err) => {
              loading.close();
            });
          } else if (this.currentRecycleBin === 2) {
            let operateArr = index.map((item)=>{
              return {
                id: this.userInfo[item].id,
                catName: this.userInfo[item].catName,
              }
            })
            this.$post("api/system/recycle/delReportOperate", {
              type: 1,
              operateArr: operateArr,
            }).then(({ data })=>{
              if (data.code == "0") {
                this.getRenderInfo();
              }
              loading.close();
            }).catch((err) => {
              loading.close();
            });
          } else {
            loading.close();
          }

        },
      })
    },

    batchingGetTableData (qObj) {

      this.queryObj.total = 0
      this.batchingObj.dataNum = 0
      this.batchingObj.loading = true
      this.batchingObj.loadingText = '获取数据中'

      let nowList = [],
          nowPage = 1,
          pageSize = 200

      let getData = (page = 1) => {

        nowPage = page

        let nowIndex = this.currentRecycleBin
        if (nowIndex == 0) {
          this.$post("api/system/recycle/delUserList", {
            curPage: page,
            pageSize: pageSize,
            name: this.searchContent,
            sex: qObj.sex,
            deptid: qObj.class,
            delStartdate: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
            delEnddate: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
            title_desc: qObj.userName,
            time_desc: qObj.time,
            level: qObj.status,
          }).then(({ data }) => {
            if (!this.batchingObj.isOn) {
              // 只有在批量处理开启时，才继续执行
              return
            }

            let dataList = data.data.list || []
            nowList.push(...dataList)

            this.recycleBinType[nowIndex].total = data.data.total;
            this.queryObj.total = data.data.total
            this.batchingObj.dataNum += dataList.length
            this.batchingObj.loadingText = `获取数据中(${ this.batchingObj.dataNum }/${ this.total })`
            
            if (dataList.length <= 0) {
              console.log('结束')
              this.batchingObj.loading = false

              this.userInfo = nowList.map((item, index)=>{
                return  {
                  ...item,
                  index,
                }
              })
              this.checkbox.length = this.userInfo.length;
              for (let i = 0; i < this.checkbox.length; i++) {
                this.checkbox[i] = false;
              }

            } else {
              console.log('完成：' + page)
              getData(page + 1)
            }
          }).catch((err) => {
            
            this.batchingObj.isOn = false
            this.batchingObj.loading = false
          });
        } else if (nowIndex == 1) {
          this.$post("api/system/recycle/delQBList", {
            curPage: page,
            pageSize: pageSize,
            catName: qObj.type,
            name: this.searchContent,
            categoryName: qObj.category,
            addUid: qObj.user,
            delStartdate: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
            delEnddate: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
            deltime_desc: qObj.time,
          }).then(({ data }) => {
            if (!this.batchingObj.isOn) {
              // 只有在批量处理开启时，才继续执行
              return
            }

            let dataList = data.data.list || []
            nowList.push(...dataList)

            this.recycleBinType[nowIndex].total = data.data.total;
            this.queryObj.total = data.data.total
            this.batchingObj.dataNum += dataList.length
            this.batchingObj.loadingText = `获取数据中(${ this.batchingObj.dataNum }/${ this.total })`
            
            if (dataList.length <= 0) {
              console.log('结束')
              this.batchingObj.loading = false

              this.userInfo = nowList.map((item, index)=>{
                return  {
                  ...item,
                  index,
                }
              })
              this.checkbox.length = this.userInfo.length;
              for (let i = 0; i < this.checkbox.length; i++) {
                this.checkbox[i] = false;
              }

            } else {
              console.log('完成：' + page)
              getData(page + 1)
            }
          }).catch((err) => {
            
            this.batchingObj.isOn = false
            this.batchingObj.loading = false
          });
        } else if (nowIndex == 2) {
          this.$post("api/system/recycle/delReportList", {
            curPage: page,
            pageSize: pageSize,
            sex: qObj.sex,
            name: this.searchContent,
            name_desc: qObj.title,
            categoryName: qObj.category,
            nickname_desc: qObj.userName,
            delStartdate: formatDate2(qObj.date[0], 'yyyy-MM-dd'),
            delEnddate: formatDate2(qObj.date[1], 'yyyy-MM-dd'),
            deltime_desc: qObj.time,
            deptid: qObj.class,
          }).then(({ data }) => {
            if (!this.batchingObj.isOn) {
              // 只有在批量处理开启时，才继续执行
              return
            }

            let dataList = data.data.list || []
            nowList.push(...dataList)

            this.recycleBinType[nowIndex].total = data.data.total;
            this.queryObj.total = data.data.total
            this.batchingObj.dataNum += dataList.length
            this.batchingObj.loadingText = `获取数据中(${ this.batchingObj.dataNum }/${ this.total })`
            
            if (dataList.length <= 0) {
              console.log('结束')
              this.batchingObj.loading = false

              this.userInfo = nowList.map((item, index)=>{
                return  {
                  ...item,
                  index,
                }
              })
              this.checkbox.length = this.userInfo.length;
              for (let i = 0; i < this.checkbox.length; i++) {
                this.checkbox[i] = false;
              }

            } else {
              console.log('完成：' + page)
              getData(page + 1)
            }
          }).catch((err) => {
            
            this.batchingObj.isOn = false
            this.batchingObj.loading = false
          });
        }
      }

      getData(1)

    },
    



  },
  created() {
    this.getClassList();
    this.getRenderInfo();
    this.getReportType();
    this.getAllCategory();
    this.getAllEditor();
    this.getTypeNum();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  .affirm {
    text-align: center;
    z-index: 1;
    div {
      padding: 0 61px 0;
      box-sizing: border-box;
      font-size: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: center;
      color: #333333;
      line-height: 30px;
    }
    /deep/ .content {
      margin-bottom: 29px;
      margin-top: 37px;
    }
  }
  
  .mainConainer {
    .head {
      width: 1430px;
      height: 60px;
      opacity: 1;
      background: #f0f0f0;
      border-radius: 10px 10px 0px 0px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      .recycleBinType {
        position: relative;
        width: 200px;
        height: 60px;
        opacity: 1;
        background: rgba(255, 255, 255, 0);
        border-radius: 10px 10px 0px 0px;
        line-height: 60px;
        text-align: center;
        &.active {
          width: 200px;
          height: 60px;
          opacity: 1;
          background: #ffffff;
          border-radius: 10px 10px 0px 0px;
        }
        span {
          position: absolute;
          display: block;
          right: 0;
          top: 2px;
          width: 30px;
          height: 20px;
          line-height: 20px;
          opacity: 1;
          background: #ff500c;
          border-radius: 4px;
          color: #fff;
        }
      }
    }
    .content {
      width: 1430px;
      height: 710px;
      opacity: 1;
      background: #ffffff;
      border-radius: 0px 0px 10px 10px;
      box-sizing: border-box;
      padding: 0 35px 0;
      position: relative;
      table {
        width: 100%;
        border-collapse: collapse;
        .checkboxAll {
          vertical-align: middle;
        }
        .label {
          display: inline-block;
          width: 40px;
          height: 20px;
          line-height: 20px;
          opacity: 1;
          background: #ffede6;
          border: 1px solid #ffa785;
          border-radius: 4px;
          font-size: 12px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: center;
          color: #ff500c;
          margin-right: 28px;
        }
        .avatar {
          width: 36px;
          height: 36px;
          margin: 6px 0;
          opacity: 1;
          border: 2px solid #3170ff;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 19px;
          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
          }
        }
        tr {
          width: 100%;
          height: 56px;
          border-bottom: 1px solid #f0f0f0;
          box-sizing: border-box;
          &:hover {
            // background-color: #f9f9f9;
          }
          th {
            position: relative;
            opacity: 1;
            font-size: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            color: #777777;
            text-align: center;
            input {
              margin-right: 5px;
            }
          }
          td {
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            /deep/ .el-checkbox-group {
              height: 56px;
            }
            &:nth-child(5) {
              .nickName {
                display: inline-block;
              }
            }
            &:nth-child(1) {
              display: flex;
              align-items: center;
            }
          }
          th:nth-child(1) {
            display: flex;
            padding: 0 0 0 30px;
          }
          th:nth-child(9) {
            overflow: hidden;
          }
          th:nth-child(2),
          th:nth-child(3),
          th:nth-child(5),
          th:nth-child(6),
          th:nth-child(7),
          th:nth-child(8),
          th:nth-child(9) {
            /deep/ .el-date-editor {
              position: absolute;
              left: -0;
              top: 0;
              opacity: 0;
              // background-color: pink;
            }
            .userNameOption,
            .serialNumberOption,
            .sexOption,
            .classOption,
            .statusOption {
              position: absolute;
              width: 160px;
              left: 50%;
              z-index: 5;
              transform: translateX(-50%);
              display: block;
              opacity: 1;
              background: #ffffff;
              border-radius: 10px;
              box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
            }
            .option {
              line-height: 50px;
            }
          }

          td:nth-child(1) {
            padding: 0 0 0 30px;
            text-align: center;
          }
          
          td:nth-last-child(1) {
            button {
              width: 80px;
              height: 40px;
              opacity: 1;
              border-radius: 6px;
              font-size: 16px;
              outline: none;
              border: 0 none;
              color: #fff;
              &:nth-child(1) {
                background: #3170ff;
                margin-right: 15px;
              }
              &:nth-child(2) {
                background: #f0f0f0;
                color: #333;
              }
            }
          }
        }
      }
      .table1 {
        .avatar {
          margin-left: 30px;
        }
        th, td {
          box-sizing: border-box;
        }
        th:nth-child(1) {
          width: 240px;
          height: 56px;
          display: flex;
          align-items: center;
          padding: 0 0 0 30px;
          div:nth-child(1) {
            margin-right: 20px;
          }
        }
        th:nth-child(2), td:nth-child(2) {
          width: 215px;
        }
        th:nth-child(3), td:nth-child(3) {
          width: 100px;
        }
        th:nth-child(4), td:nth-child(4) {
          width: 90px;
        }
        th:nth-child(5), td:nth-child(5) {
          width: 180px;
        }
        th:nth-child(6), td:nth-child(6) {
          width: 130px;
        }
        th:nth-child(7), td:nth-child(7) {
          width: 170px;
        }
        th:nth-child(8), td:nth-child(8) {
          width: 235px;
        }
        td:nth-child(1) {
          width: 240px;
          height: 56px;
          display: flex;
          align-items: center;
        }
      }
      .table2 {
        .label {
          margin-left: 15px;
          margin-right: 20px;
        }
        th, td {
          box-sizing: border-box;
        }
        th:nth-child(1) {
          width: 400px;
          height: 56px;
          display: flex;
          align-items: center;
          padding: 0 0 0 30px;
          div:nth-child(1) {
            margin-right: 90px;
          }
        }
        th:nth-child(2), td:nth-child(2) {
          width: 200px;
        }
        th:nth-child(3), td:nth-child(3) {
          width: 150px;
        }
        th:nth-child(4), td:nth-child(4) {
          width: 150px;
        }
        th:nth-child(5), td:nth-child(5) {
          width: 225px;
        }
        th:nth-child(6), td:nth-child(6) {
          width: 235px;
        }
        td:nth-child(1) {
          height: 56px;
          display: flex;
          align-items: center;
        }
      }
      .table3 {
        .label {
          margin-left: 15px;
          margin-right: 20px;
        }
        .userName {
          max-width: 230px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .avatar {
          margin: 0 15px;
        }
        th, td {
          box-sizing: border-box;
        }
        th:nth-child(1) {
          width: 360px;
          height: 56px;
          display: flex;
          align-items: center;
          padding: 0 0 0 30px;
          div:nth-child(1) {
            margin-right: 70px;
          }
        }
        th:nth-child(2), td:nth-child(2) {
          width: 150px;
        }
        th:nth-child(3), td:nth-child(3) {
          width: 120px;
        }
        th:nth-child(4), td:nth-child(4) {
          width: 135px;
        }
        th:nth-child(5), td:nth-child(5) {
          width: 130px;
        }
        th:nth-child(6), td:nth-child(6) {
          width: 60px;
        }
        th:nth-child(7), td:nth-child(7) {
          width: 60px;
        }
        th:nth-child(8), td:nth-child(8) {
          width: 110px;
        }
        th:nth-child(9), td:nth-child(9) {
          width: 235px;
        }
        td:nth-child(1) {
          height: 56px;
          display: flex;
          align-items: center;
        }
        td:nth-child(4) {
          >div {
            height: 56px;
            display: flex;
            align-items: center;
          }
        }
      }
      .page {
      }
    }
  }
  .addWidnow .dialog {
    .wrap {
      padding: 40px 100px 35px 100px;
      width: 100%;

      box-sizing: border-box;
      .setPWD {
        margin-top: 24px;
      }
      > .explain {
        display: block;
        font-size: 14px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        font-weight: 400;
        text-align: left;
        color: #777777;
        margin-left: 100px;
        margin-top: 24px;
      }
      .userNameAndSex {
        margin-top: 34px;
      }
      .classAndSerialNumber {
        margin-top: 24px;
        > .explain {
          margin-right: 24px !important;
        }
      }
      .register,
      .setPWD,
      .userNameAndSex,
      .classAndSerialNumber {
        display: flex;
        align-items: center;
        .explainSex {
          margin: 0 38px 0 18px;
        }
        .explainSerialNumber {
          margin: 0 28px 0 19px;
        }
        .serialNumber {
          width: 100px;
          height: 40px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 4px;
        }

        .sexArr {
          width: 140px;
          height: 40px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 4px;

          /deep/ .el-input__inner {
            width: 140px;
            height: 40px;
            opacity: 1;
            background: #f0f0f0;
            border-radius: 4px;
            border: 0 none;
            &:focus {
              border: 0 none;
            }
          }
        }
        .classList {
          width: 280px;
          height: 40px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 4px;
          border: 0 none;
          /deep/ .el-input__inner {
            width: 280px;
            height: 40px;
            opacity: 1;
            background: #f0f0f0;
            border-radius: 4px;
            border: 0 none;
            &:focus {
              border: 0 none;
            }
          }
        }
        > .explain {
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: left;
          color: #333333;
          margin-right: 29px;
        }
        input {
          width: 240px;
          height: 40px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 4px;
          outline: none;
          border: 0 none;
        }
        .PWD {
          width: 240px;
          height: 40px;
          opacity: 1;
          background: #f0f0f0;
          border-radius: 4px;
          outline: none;
          border: 0 none;
        }
        .speedinessSet {
          width: 80px;
          height: 36px;
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid #c9c9c9;
          border-radius: 6px;
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          text-align: center;
          color: #7f7f7f;
          margin-left: 25px;
        }
      }
    }
  }

  .data-table {
    max-height: 620px;
    .grid {
      width: 100%;
      >div {
        width: 100%;
      }
    }
    // table tr {
    //   position: relative;
    //   height: 57px !important;
    //   border-bottom: none !important;
    //   &::after{		
    //     content:"";
    //     position: absolute;
    //     display: block;
    //     background: #F0F0F0 !important;
    //     width: 100%;
    //     height: 1px;
    //     left: 0;
    //     bottom: 0;
    //   }
    // }
  }
}
</style>